import { type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Merge class names, with later ones winning over earlier conflicts.
 *
 * **tailwind-merge has to be told about the custom scale**, and this cost an hour.
 * It groups classes so a later one can drop an earlier one in the same group, and
 * it knows Tailwind's own names — `text-sm`, `text-lg`. It does not know
 * `text-body` or `text-display`, so it guessed: a `text-*` it cannot place is read
 * as a **colour**, which put `text-display` and `text-ink` in one group and threw
 * the size away. Every heading in the product rendered at body size, and the markup
 * looked right — the class was simply not in the output.
 *
 * Found by measuring the rendered element rather than by looking at a screenshot,
 * which is the lesson worth keeping: "it looks a bit small" is not a finding, and
 * `getComputedStyle` is.
 */
export const cn = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['micro', 'caption', 'second', 'body', 'title', 'display'] },
      ],
    },
  },
}) as (...inputs: ClassValue[]) => string
